import React, { useState } from "react";
import { useSelector } from "react-redux";
import Layout from "antd/es/layout/layout";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar/Main";

const CustomLayout = ({
  pageName,
  nestedName,
  children,
  hideFooter = false,
  customNestedName = null,
  customPageNameNavigation = null,
}) => {
  const { theme } = useSelector((state) => state.loggedInUser);

  const [sidebarActive, setSidebarActive] = useState(false);

  return (
    <Layout
      className={` ${theme} flex-row w-screen h-screen overflow-hidden relative`}
    >
      {/* to close the sidebar if it is open and user clicks outside the sidebar area */}
      {sidebarActive ? (
        <div
          className="bg-transparent absolute z-[999] top-0 w-screen h-screen"
          onClick={() => setSidebarActive(false)}
        />
      ) : null}

      <Sidebar
        pageName={pageName}
        sidebarActive={sidebarActive}
        setSidebarActive={setSidebarActive}
      />

      {/* ml-18 === size of the sidebar when inactive */}
      <Layout className="ml-18">
        <Header
          pageName={pageName}
          nestedName={nestedName}
          customNestedName={customNestedName}
          customPageNameNavigation={customPageNameNavigation}
        />

        <div className="w-full h-full">{children}</div>

        {hideFooter ? null : <Footer />}
      </Layout>
    </Layout>
  );
};

export default CustomLayout;
